import {Branding} from "@irati/types"

const logo = "https://res.cloudinary.com/perkbox/image/upload/v1762340794/5f706816-8937-4ff2-8f1f-405d738f565f.jpg"

const defaultBranding: Branding = {
  uuid: "uuid",
  businessId: "busiensId",
  teamId: "teamId",
  businessLogoUrl: logo,
  businessSquareLogoUrl: "",
  isEnabled: true,
  primaryColour: "#402AFF",
  textColour: "#000"
}

export default defaultBranding
